import {Features} from "./api";
import {Reactivity} from "./reactivity";

export const Observer = {

    helpers: {
        /**
         * Checks if the property was created with Def()
         * @param target
         * @param key
         * @returns {{yes: boolean, name: *}|{yes: boolean, name}}
         */
        isDef: (target, key) => {
            if (target) {
                if (target['name']) {
                    return {yes: true, name: target['name']};
                }
                else {
                    return {yes: false, name: key};
                }
            }
        },
    },

    handler: {

        get(target, key) {
            //* return prop
            return target[key];
        },

        set(target, key, value) {
            Reflect.set(target, key, value);

            // check if property was created with Def()
            const isDef = Observer.helpers.isDef(target, key);
            if (isDef.yes) {
                Observer.finish({
                    isDef,
                    property: key,
                });
            }
            else {
                Observer.finish({
                    isDef,
                    property: key,
                });
            }

            // check for observers
            if (Features.Observers[isDef.name]) Features.Observers[isDef.name](Features.VM[isDef.name]);

            return true;
        },

        deleteProperty(target, key) {
            Reflect.deleteProperty(target, key);
            return true;
        },

    },

    /**
     * Will start watching object for changes
     * @param {Object} data
     * @returns {Object}
     * @constructor
     */
    Observe: (data) => {
        return new Proxy(data, Observer.handler);
    },

    /**
     *  Will start the HTML update process
     * @param {{property: String, isDef: Boolean}} data
     */
    finish: (data) => {
        // check if this is the initial Expose() call
        if (!Features.exposeInitialRun) {

            // check if property was created using Def()
            if (data.isDef.yes) {
                const interpolatedValue = data.isDef.name;
                Reactivity.ApplyDomUpdates({
                    template: document,
                    loadedVM: Features.VM,
                    propertyToUpdate: interpolatedValue,
                    isDef: true
                });
            }
            else {
                Reactivity.ApplyDomUpdates({
                    template: document,
                    loadedVM: Features.VM,
                    propertyToUpdate: data.property,
                    isDef: false
                });
            }

        }
    },

};